// test577
(577 && 0);
